import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';
import { TypedMemo } from '../../../common/types';
import { songsBrewMessages as messages } from './songsBrewMessages';
import styles from './SongsBrewSendTrack.module.scss';

interface Props {
  sendTrackUrl: string;
  className?: string;
}

/**
 * The perk for a subscribed artist: "Want SongsBrew to hear your music? Send us your track"
 * (design: songsbrew-promotion a4 and c3). The link opens `sendTrackUrl` in a new tab.
 */
const SongsBrewSendTrackComponent: React.FC<Props> = ({ sendTrackUrl, className }) => {
  const intl = useIntl();
  return (
    <div className={clsx(styles.perk, className)}>
      <span>{intl.formatMessage(messages.sendTrackPrompt)}</span>
      <a className={styles.link} href={sendTrackUrl} target="_blank" rel="noopener noreferrer">
        {intl.formatMessage(messages.sendTrackLink)}
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
      </a>
    </div>
  );
};

export const SongsBrewSendTrack = TypedMemo(SongsBrewSendTrackComponent);
